/**
 * Returns true if the current environment is a test run.
 */
function isTestRunEnv(): boolean {
  return process.env.NODE_ENV === "test";
}

export { isTestRunEnv };
